<section class="hvac-account-admin-header hvac-program-search-header">
    <hvac-content-header [data]="(accountAdminProgramService.getProgramAdminBreadCrumData() | async) || breadCrumbData"></hvac-content-header>
</section>

<section class="hvac-content-container">
    <router-outlet></router-outlet>   
</section>